import { PinButton } from "../../../dentlab/src/layout/layout-components/app-bar/app-bar-components/pin-button/pin-button.component";
import {
	APP_BAR_ANIMATION,
	APP_BAR_COLORS,
	APP_BAR_PADDING,
	APP_BAR_WIDTHS,
} from "../../../dentlab/src/layout/layout-components/app-bar/app-bar-constants";
import { cn } from "@/dentlab/src/lib/utils/cn";

interface SideNavigationProps {
	children: React.ReactNode;
	topLeftMenu: React.ReactNode;
	isExpanded: boolean;
	isPinned: boolean;
	handleMouseEnter: () => void;
	handleMouseLeave: () => void;
	togglePin: () => void;
	className?: string;
}

/**
 * SideNavigation - Main sidebar navigation component
 * Features:
 * - Collapsed by default, expands on hover
 * - Can be pinned to stay expanded
 * - Shows client list and application navigation icons
 */
export const SideNavigation: React.FC<SideNavigationProps> = ({
	children,
	topLeftMenu,
	isExpanded,
	isPinned,
	handleMouseEnter,
	handleMouseLeave,
	togglePin,
	className,
}) => {
	const handlePinClick = () => {
		document.body.classList.toggle("sidebar-expanded");
		togglePin();
	};

	return (
		<div
			className={cn(
				`h-screen flex-shrink-0 ${APP_BAR_COLORS.BACKGROUND} flex flex-col transition-all ${APP_BAR_ANIMATION.DURATION} ease-in-out`,
				className,
				isExpanded || isPinned
					? APP_BAR_WIDTHS.EXPANDED + " " + APP_BAR_PADDING.EXPANDED
					: APP_BAR_WIDTHS.COLLAPSED +
							" " +
							APP_BAR_PADDING.COLLAPSED,
				isExpanded && !isPinned ? "expanded" : ""
			)}
			onMouseEnter={handleMouseEnter}
			onMouseMove={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
		>
			<div className="h-12 flex items-center justify-between flex-shrink-0">
				{topLeftMenu}
				{(isExpanded || isPinned) && (
					<div className="flex-shrink-0">
						<PinButton
							isPinned={isPinned}
							onClick={handlePinClick}
						/>
					</div>
				)}
			</div>
			<div className="flex-1 min-h-0 overflow-hidden flex flex-col py-2 w-full">
				{children}
			</div>
		</div>
	);
};
